import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router";

import Footer from "@/components/Footer/Footer.jsx";
import Loading from "@/components/Loading/Loading.jsx";
import LoginScreen from "@/components/LoginScreen/LoginScreen";
import Navbar from "@/components/Navbar/Navbar.jsx";
import SessionTimeoutModal from "@/components/SessionTimeout/SessionTimeoutModal";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext.jsx";
import {
  canChangeWorkflow,
  politicalWorkflowOnly,
} from "@/utils/permissionsHandler.js";

function MainView() {
  const { isLoading, isAuthenticated, user } = useAuth0();
  const { handleWorkflowChange } = useUpdateDataContext();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated && user) {
      console.log(user.role);
      const isAtBaseCustomPath =
        location.pathname === "/" || location.pathname === "/dashboard";

      // redirect if the user isn't already heading somewhere specific
      if (isAtBaseCustomPath) {
        if (canChangeWorkflow(user)) {
          if (localStorage.getItem("workflow") == "political") {
            handleWorkflowChange("political");
            navigate("/political/update-data/select-file");
          } else {
            handleWorkflowChange("membership");
            navigate("/membership/dashboard");
          }
        } else if (politicalWorkflowOnly(user)) {
          handleWorkflowChange("political");
          navigate("/political/update-data/select-file");
        } else {
          handleWorkflowChange("membership");
          navigate("/membership/dashboard");
        }
      }
    }
    // handleWorkflowChange is recreated by UpdateDataContext on every render
    // and navigate (from useNavigate) is stable but referenced here.
    // We intentionally only react to user/location changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, location.pathname]);

  return (
    <>
      {isLoading && <Loading />}
      {!isLoading && !isAuthenticated && <LoginScreen />}
      {!isLoading && isAuthenticated && (
        <>
          <Navbar />
          <div>
            <Outlet />
          </div>
          <Footer />
        </>
      )}
      {isAuthenticated && <SessionTimeoutModal />}
    </>
  );
}

export default MainView;
